import { Token, TokenRequest, TokenResponse } from 'types';

import { API } from 'services';
import { AuthStore as AuthStoreInterface } from 'interfaces';
import { ENDPOINTS } from 'endpoints';
import { makeAutoObservable } from 'mobx';

class AuthStore implements AuthStoreInterface {
  constructor() {
    makeAutoObservable(this);
  }

  token: Token = null;

  setToken = (token: Token): void => {
    this.token = token;
  };

  getToken = async (): Promise<Token> => {
    const response = await API.post<TokenRequest, TokenResponse, unknown>({
      resource: ENDPOINTS.AUTH,
      options: {
        body: {
          client_id: process.env.REACT_APP_CLIENT_ID as string,
          client_secret: process.env.REACT_APP_CLIENT_SECRET as string,
          grant_type: process.env.REACT_APP_GRANT_TYPE as string,
          scope: process.env.REACT_APP_SCOPE as string,
        },
      },
    });
    return response.data.access_token;
  };

  get hasToken() {
    return !!this.token;
  }
}

export default AuthStore;
